import React from 'react';
import { i18n } from '@lt/localization';

import CustomBooleanFilterGroup from '../components/CustomBooleanFilterGroup';
import type { IFilter } from '../types';

const FILTER_NAMES = {
  fitness: i18n.t('filters.facility.fitness'),
  aircon: i18n.t('filters.facility.aircon'),
  parking: i18n.t('filters.facility.parking'),
  bar: i18n.t('filters.facility.bar'),
  massage: i18n.t('filters.facility.massage'),
  ski_in: 'Ski-in',
  ski_out: 'Ski-out',
};

const FilterConfig = {
  filterLabel: i18n.t('filters.facility.title'),
  FILTER_NAMES,
  customFilters: Object.keys(FILTER_NAMES),
};

const FilterFacilities = ({
  isMobile = false,
  className = '',
  ...props
}: IFilter): JSX.Element => (
  <CustomBooleanFilterGroup
    isMobile={isMobile}
    className={className}
    Filter={{
      filterLabel: i18n.t('filters.facility.title'),
      FILTER_NAMES,
      customFilters: Object.keys(FILTER_NAMES),
    }}
    {...props}
  />
);

export default Object.assign(FilterFacilities, {
  filterName: 'facilities',
  ...FilterConfig,
});
